// extracted by mini-css-extract-plugin
export default {"card":"CountCard_card__T4F6C","buttons":"CountCard_buttons__h9hvh","counter":"CountCard_counter__Pmvx3","sub-title":"CountCard_sub-title__tKA74","symbol":"CountCard_symbol__DYoe1"};